// @flow
import React from 'react'

const MasterCard = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0-4h32v32H0z" />
        <g fillRule="nonzero" transform="translate(.5 .5)">
          <path
            fill="#243747"
            d="M28.5 0h-26A2.503 2.503 0 0 0 0 2.5v18A2.503 2.503 0 0 0 2.5 23h26a2.503 2.503 0 0 0 2.5-2.5v-18A2.503 2.503 0 0 0 28.5 0z"
          />
          <circle cx="12" cy="11.5" r="5" fill="#E61C24" />
          <circle cx="19" cy="11.5" r="5" fill="#F99F1B" />
          <path
            fill="#F26622"
            d="M15.5 7.93A4.985 4.985 0 0 1 17 11.5a4.985 4.985 0 0 1-1.5 3.57A4.985 4.985 0 0 1 14 11.5c0-1.399.574-2.663 1.5-3.57z"
          />
        </g>
      </g>
    </svg>
  )
}

export default MasterCard



// WEBPACK FOOTER //
// ./src/components/Icons/MasterCard.js